import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { IShelfDivider } from '../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';

export interface IShelfDividerItemProps {
  shelfDivider: IShelfDivider;
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
  title?: string;
}

interface IShelfDividerItemState {
  hover: boolean;
}
class ShelfDividerItem extends React.Component<IShelfDividerItemProps, IShelfDividerItemState> {

  constructor(props: any) {
    super(props);
    this.state = {
      hover: false,
    };
  }


  render() {

    if (this.props.connectDragSource == undefined) {
      return (<li>{this.props.shelfDivider.category.name}</li>);
    }

    const isDragging = (this.props.isDragging != undefined) ? this.props.isDragging : false;
    const className = `product-list-item ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(isDragging);
    return this.props.connectDragSource(
      <li
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onMouseDown={() => this.setState({ hover: false })}
        data-title={this.props.title ? this.props.title : null}
        className={`${className} ${this.state.hover ? 'open' : ''}`}
      >{this.props.shelfDivider.category.name}</li>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: props.shelfDivider,
      type: placeholderTypes.Divider,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(ShelfDividerItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/ShelfDividerItem.tsx